module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "hidden",
      "width": "100%",
      "z-index": "-10"
    }
  }, [_c('div', {
    directives: [{
      name: "hammer",
      rawName: "v-hammer:pan",
      value: (_vm.onSwipe),
      expression: "onSwipe",
      arg: "pan"
    }],
    staticStyle: {
      "display": "flex",
      "flex-wrap": "nowrap",
      "width": "100%",
      "z-index": "-10"
    },
    style: ({
      'transform': 'translate3d(' + _vm.x + 'px, 0px, 0px)'
    }),
    attrs: {
      "id": "swipe"
    }
  }, [_c('div', {
    staticClass: "statistic-wrap"
  }, [_c('div', {
    staticClass: "card statistic-table"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n              " + _vm._s(("" + (_vm.$t('pages.cross_sell')))) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "background-color": "#e0e0e0"
    }
  }, [_vm._v("Операторы")]), _vm._v(" "), _vm._l((_vm.headColumns), function(col) {
    return _c('th', {
      staticStyle: {
        "white-space": "nowrap",
        "cursor": "pointer"
      },
      style: ({
        background: col.isMain ? '#ffd96a' : col.color
      }),
      attrs: {
        "colspan": "2"
      },
      on: {
        "click": function($event) {
          _vm.isPopup(col)
        }
      }
    }, [_vm._v(_vm._s(col.label))])
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "#81c784"
    }
  }, [_vm._v("Одобрено")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "#fff9c4"
    }
  }, [_vm._v("Общее кол-во")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "#90caf9"
    }
  }, [_vm._v("Средний чек")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "#8fbc8f"
    }
  }, [_vm._v("Апрув от валида")])], 2)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.rows), function(rowItems) {
    return _vm._l((rowItems), function(row, operator) {
      return _c('tr', [_c('td', {
        staticStyle: {
          "background-color": "#e0e0e0"
        }
      }, [_vm._v(_vm._s(_vm.findOperator(operator)))]), _vm._v(" "), _vm._l((row), function(item) {
        return [_c('td', {
          staticStyle: {
            "background-color": "#fff9c4"
          }
        }, [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('td', {
          staticStyle: {
            "background-color": "#90caf9"
          }
        }, [_vm._v(_vm._s(item.quantity > 0 ? '$ ' + (item.total_bill / item.quantity).toFixed(2) : 0))])]
      }), _vm._v(" "), _c('td', {
        staticStyle: {
          "background-color": "#81c784"
        }
      }, [_vm._v(_vm._s(row.Approved))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background-color": "#fff9c4"
        }
      }, [_vm._v(_vm._s(row.Quantity))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background-color": "#90caf9"
        }
      }, [_vm._v(_vm._s(row.AverageBill))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "background-color": "#8fbc8f"
        }
      }, [_vm._v(_vm._s(_vm.approvedFromValid(row.Approved, row.Total, row.Spam)))])], 2)
    })
  })], 2), _vm._v(" "), _c('tfoot', [_c('tr', [_c('th', {
    staticStyle: {
      "background-color": "#e0e0e0"
    }
  }, [_vm._v("Итого:")]), _vm._v(" "), _vm._l((_vm.footColumns), function(row) {
    return [_c('th', {
      staticStyle: {
        "background-color": "#fff9c4"
      }
    }, [_vm._v(_vm._s(row.footQuantity))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "background-color": "#90caf9"
      }
    }, [_vm._v(_vm._s(row.footQuantity > 0 ? '$ ' + (row.footTotal / row.footQuantity).toFixed(2) : 0))])]
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "#81c784"
    }
  }, [_vm._v(_vm._s(_vm.footColumns.footSumApproved))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "#fff9c4"
    }
  }, [_vm._v(_vm._s(_vm.footColumns.footSumQuantity))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "#90caf9"
    }
  }, [_vm._v(_vm._s(_vm.footColumns.footSumAverageBill))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "#8fbc8f"
    }
  }, [_vm._v(_vm._s(_vm.approvedFromValid(_vm.footColumns.footSumApproved, _vm.footColumns.footSumTotal, _vm.footColumns.footSumSpam)))])], 2)])], 1)])])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "effect": "fade/zoom"
    },
    model: {
      value: (_vm.crossSellModal),
      callback: function($$v) {
        _vm.crossSellModal = $$v
      },
      expression: "crossSellModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.titleModal))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "search_offers"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Поиск оффера..."
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "offers"
  }, _vm._l((this.filterRowsModal), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "offers_items",
      class: _vm.getClasses(item),
      on: {
        "click": function($event) {
          _vm.selectedOffers(item)
        }
      }
    }, [_c('div', [_vm._v(_vm._s(item.offerName))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.crossSellApply()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('verbs.save')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.crossSellModal = false
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('verbs.close')))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c9b8936"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/operators/CrossSell.vue
// module id = 574
// module chunks = 0